import { render, staticRenderFns } from "./platform.vue?vue&type=template&id=69ad994a&scoped=true"
import script from "./platform.vue?vue&type=script&lang=ts"
export * from "./platform.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69ad994a",
  null
  
)

export default component.exports